<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form @submit.prevent="askToSend()" novalidate>
                <div class="modal-header">
                    <button type="button" class="close" @click="goBack()" aria-hidden="true">×</button>
                    <h4 class="modal-title">{{ $t('email') }}</h4>
                </div>
                <div class="modal-body p-0">
                    <div class="modal_deal" v-pml-block="isLoading">
                        <div class="row">
                            <div class="col-sm-8 m_bottom_15" :class="{'has-error': errors['template_id']}">
                                <label>{{ $t('template') }}</label>
                                <pml-select v-model="record.template_id" :options="templates" label="title"></pml-select>
                                <span class="error" v-if="errors['template_id']">{{ errors['template_id'][0] }}</span>
                            </div>
                        </div>
                        <div class="d_flex flex_wrap h_34 m-t-15 f_justify_end w_full_450">
                            <div class="m-r-10" v-if="record.is_scheduled" :class="{'has-error': errors['scheduled_at']}">
                                <pml-datetime-picker v-model="record.scheduled_at" v-pml-focus class="w_140"></pml-datetime-picker>
                                <span class="show error text-center" v-if="errors['scheduled_at']">{{ errors['scheduled_at'][0] }}</span>
                            </div>
                            <pml-switch v-model="record.is_scheduled" :text="$t('set_scheduling')" class="switch_text_left m-r-15"></pml-switch>
                        </div>
                    </div>
                </div>
                <div class="p-15 t_right">
                    <span class="btn btn-white pull-left btn_mobile_block" @click="goBack()">{{ $t('cancel') }}</span>
                    <button type="submit" class="btn btn-default btn_mobile_block" v-pml-block="isSaving">{{ $t('save') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import RoutedModals from 'utils/mixins/routed-modals'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { mapGetters } from 'vuex'
    import { createMassive } from 'services/emails'
    import { sendEmail } from 'utils/helpers/sweet-alert'
    import bus from 'utils/events/bus'

    export default {
        name: 'EmailCreate',
        mixins: [ RoutedModals ],
        data () {
            return {
                isSaving: false,
                isLoading: false,
                record: {
                    template_id: null,
                    scheduled_at: '',
                    schedule: false,
                    ids: []
                },
                errors: []
            }
        },
        mounted () {
            this.record.ids = JSON.parse(this.$route.query.ids)
        },
        metaInfo () {
            return {
                title: trans('create_a_new_email')
            }
        },
        computed: {
            ...mapGetters({
                'member': 'getMember',
                'templates': 'getTemplates'
            })
        },
        methods: {
            askToSend (redirect) {
                sendEmail()
                    .then((response) => (response.value) ? this.store(redirect) : null)
            },
            store () {
                this.isSaving = true

                createMassive(this.record)
                    .then(response => {
                        bus.$emit('selectedAll', false)
                        Notify.success(trans('_notifications.success'))
                        this.clear()
                        this.goBack()
                    })
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => { this.isSaving = false })
            },
            clear () {
                this.isSaving = false
                this.record = {
                    template_id: null,
                    is_scheduled: false
                }
                this.errors = []
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/emails/massive/components/Create.vue